import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import InvitadoForm from "./views/InvitadoForm.js";
import NotFound from "./views/NotFound.js";

function App() {
  return (
    <Router>
      <Switch>
        {/* <Route exact path="/" component={InvitadoForm} /> */}
        <Route path="/:hashkey" exact component={InvitadoForm} />
        <Route path="*" component={NotFound} />
      </Switch>
    </Router>
  );
}

export default App;